import { twMerge } from 'tailwind-merge'
import { LinkTabItem } from './LinkTabItem'

export interface LinkTabsProps {
  children: React.ReactNode
  className?: string
}

const LinkTabsComponent = ({ children, className }: LinkTabsProps) => {
  return <ul className={twMerge('flex gap-4', className)}>{children}</ul>
}

export const LinkTabs = Object.assign(LinkTabsComponent, {
  Item: LinkTabItem,
})
